import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../../utils/analytics";

/**
 * Navigate to `/reminders`. Guests can complete setup first; login is prompted at connect.
 */
export const useNavigateToReminders = () => {
  const navigate = useNavigate();

  return useCallback(
    (source = "unknown") => {
      trackEvent("reminder_cta_click", { source });
      navigate("/reminders");
    },
    [navigate],
  );
};
